import { useCallback } from 'react'

import { getFavoriteToastActions } from '../../../components/global/favorites/FavoriteToastActions'
import { useCopy } from '../../i18n/useCopy'
import { useUniqueToast } from '../../toasts/hooks/useUniqueToast'

export interface ShowRemovedToastOptions {
  productName?: string | null
  onUndo?: () => void
}

export interface UseFavoriteToast {
  showRemovedToast: (options?: ShowRemovedToastOptions) => void
  showErrorToast: (productName?: string | null) => void
}

export const useFavoriteToast = (): UseFavoriteToast => {
  const { showToast, hideToastById } = useUniqueToast({ toastIdPrefix: 'favorite-' })
  const { removedToast, errorToast } = useCopy().favorites

  const showRemovedToast = useCallback(
    ({ productName, onUndo }: ShowRemovedToastOptions = {}) => {
      showToast(removedToast(productName), {
        variant: 'success',
        action: getFavoriteToastActions({ onUndo, dismissToast: hideToastById }),
        style: { flexWrap: 'nowrap', alignItems: 'center' },
      })
    },
    [showToast, hideToastById, removedToast],
  )

  const showErrorToast = useCallback(
    (productName?: string | null) => {
      showToast(errorToast(productName), {
        variant: 'error',
        action: getFavoriteToastActions({ dismissToast: hideToastById }),
        style: { flexWrap: 'nowrap', alignItems: 'center' },
      })
    },
    [showToast, hideToastById, errorToast],
  )

  return { showRemovedToast, showErrorToast }
}
